import { localizable } from 'components/Localization';
import { computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import {
  Dialog,
  DialogFooter,
  DialogType,
} from 'office-ui-fabric-react/lib/Dialog';
import React, { Component, Fragment } from 'react';
import ToggleField from '../../../components/ToggleField';
import RoundDurationEdit from './RoundDurationEdit';
import RoundPriceEdit from './RoundPriceEdit';
import { RoundTypeSelector } from './RoundTypeSelector';

@inject('app', 'sale')
@localizable
@observer
class RoundEdit extends Component {
  @observable openRoundWarning = false;

  @computed get eligibleRounds() {
    const { store, allowedRounds, disallowedRounds, sale } = this.props;

    const config = sale.saleConfig;
    const rounds = [
      ...new Set(
        !!config.getRoundTypes
          ? config.getRoundTypes(store)
          : undefined ||
            config.roundTypes.filter(
              (r) =>
                (!allowedRounds || allowedRounds.indexOf(r) >= 0) &&
                (!disallowedRounds || disallowedRounds.indexOf(r) < 0)
            )
      ),
    ];

    const round = store.round;
    if (
      round.type &&
      round.type !== 'none' &&
      rounds.indexOf(store.round.type) < 0
    ) {
      rounds.push(round.type);
    }

    return rounds;
  }

  @computed get canChangeType() {
    return this.props.store.canChangeType || this.props.allowChangeType;
  }

  handleToggleChanged = (field) => (_, value) => {
    var {
      store: { round },
    } = this.props;
    round[field] = value;
  };

  componentDidMount() {
    const {
      store: { round },
    } = this.props;

    if (!this.eligibleRounds || this.eligibleRounds.length === 1) {
      // if there's only one eligible round, set it a as default value
      round.type = this.eligibleRounds[0];
    }
  }

  handleSelect = (type) => {
    const {
      store: { round, defaultStartsAt, allowConditionsForRound },
    } = this.props;
    round.type = type;
    round.durationType = 'fixed';
    round.startsAt = defaultStartsAt(type);
    round.allowConditions = allowConditionsForRound(type);
    switch (round.type) {
      case 'sealed_bidding':
        this.openRoundWarning = false;
        break;
      case 'open_bidding':
      case 'incremental_auction':
        round.estimate = '';
        round.redButtonPrice = '';
        this.openRoundWarning = true;
        break;
      default:
        round.startPrice = '';
        round.estimate = '';
        round.redButtonPrice = '';
        round.biddingSteps = '';
        this.openRoundWarning = false;
        break;
    }
  };

  render() {
    const {
      store,
      store: { round },
      intl,
      t,
      sale,
    } = this.props;

    const config = sale.saleConfig;
    const isSimpleOffer = round.type === 'simple_offer';

    return (
      <Fragment>
        {/* {this.openRoundWarning && this.renderWarning()} */}
        <RoundTypeSelector
          rounds={this.eligibleRounds.map((type) => {
            return {
              type: type,
              title: t(`roundtype::${type}`),
              description: t(`roundtype::${type}_description`),
              selected: type === round.type,
            };
          })}
          onSelect={this.handleSelect}
          disabled={!this.canChangeType}
        />
        {round.type && round.type !== 'none' ? (
          <Fragment>
            <RoundDurationEdit
              store={store}
              intl={intl}
              t={t}
              canChangeDurationType={isSimpleOffer}
              hideValidity={
                config.roundHideValidity || round.type === 'registration'
              }
            />
            {store.showAllowConditionsToggle ? (
              <div style={{ marginTop: '0.5em' }}>
                <ToggleField
                  label={t('roundtype::allow_conditions')}
                  tooltip={t('roundtype::allow_conditions_tooltip')}
                  onChange={this.handleToggleChanged('allowConditions')}
                  checked={round.allowConditions}
                />
              </div>
            ) : null}
            {!isSimpleOffer && config.roundShowInvitedCustomersCount ? (
              <div style={{ marginTop: '0.5em' }}>
                <ToggleField
                  label={t('roundtype::show_invited_customers_count')}
                  tooltip={t('roundtype::show_invited_customers_count_tooltip')}
                  onChange={this.handleToggleChanged(
                    'showInvitedCustomersCount'
                  )}
                  checked={round.showInvitedCustomersCount}
                />
              </div>
            ) : null}
            {isSimpleOffer || round.type === 'registration' ? null : (
              <RoundPriceEdit
                store={store}
                intl={intl}
                t={t}
                overrideStartPrice={this.props.overrideStartPrice}
              />
            )}
          </Fragment>
        ) : null}
      </Fragment>
    );
  }

  renderWarning = () => {
    const { t } = this.props;
    const close = () => (this.openRoundWarning = false);
    return (
      <Dialog
        hidden={false}
        onDismiss={close}
        dialogContentProps={{
          type: DialogType.close,
        }}
        modalProps={{
          titleAriaId: 'myLabelId',
          subtitleAriaId: 'mySubTextId',
          isBlocking: true,
          containerClassName: 'ms-dialogMainOverride',
        }}
      >
        {t('open round warning')}
        <DialogFooter>
          <PrimaryButton onClick={close} text={t('Ok')} />
        </DialogFooter>
      </Dialog>
    );
  };
}

export default RoundEdit;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/RoundSection/RoundEdit.jsx